<template>
  <div v-if="fileReady">
    <viewer
      @inited="inited"
      :options="viewerOptions"
      ref="viewer"
      :images="imgs"
      class="pd-5"
    >
      <template v-if="prms.isFull != undefined && prms.isFull">
        <img
          v-for="(src, index) in imgs"
          :key="index"
          :src="src"
          class="rounded bd mg-r-5 wd-40p mg-b-5"
        />
      </template>
      <div v-else class="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-10 xl:grid-cols-12 gap-2 relative">
        <img
          v-for="(src, index) in imgs"
          :key="index"
          :src="src"
          class="rounded-10 border-2 cursor-pointer"
        />
      </div>
    </viewer>
  </div>
</template>
<script>
import { fileInheritedDetail } from "@/api/media";
import { request } from "@/api/all";

export default {
  name: "detail",
  props: {
    propFileId: {
      type: Number,
      default: () => null,
    },
    minusHeight: {
      type: Number,
      default: () => 115,
    },
    force: {
      type: Boolean,
      default: () => false,
    },
    prms: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgs: [],
      pageCount: null,
      curPage: 1,
      PDFJS_URL: "https://res.gosmart.mn/static/pdfobject/web/viewer.html",
      fileReady: false,
      file: {},
      deletingFileId: 0,
      index: 0,
      viewLog: {
        second: 0,
      },
      viewerOptions: {
        inline: false,
        initialViewIndex: 0,
        movable: false,
        viewed:(e) => {
          this.updateViewLog(e.detail.index)
        },
      },
    };
  },

  mounted() {
    this.configure();
  },
  methods: {
    fetchAfter() {
      let self = this;
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }
      request({
        api: { method: "POST", url: "Media/GetLastVideoViewLog" },
        data: {
          attachId: _id,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.viewLog = res.data.viewLog;
          if (res.data.viewLog != null && res.data.viewLog.second == 0) {
            self.updateViewLog(0);
          } else {
            if (res.data.viewLog.second > 0)
              this.curPage = res.data.viewLog.second;
            this.viewerOptions.initialViewIndex = this.curPage;
          }
        }
      });
    },
    inited(viewer) {
      this.$viewer = viewer;
      this.$viewer.show();
    },
    configure() {
      if (
        this.$store.state.app.activeGroup.PDFJS_URL != undefined &&
        this.$store.state.app.activeGroup.PDFJS_URL != ""
      ) {
        this.PDFJS_URL = this.$store.state.app.activeGroup.PDFJS_URL;
      }

      this.init();
    },
    updateViewLog(page, isFullView) {
      //let self = this;
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }      
      if(this.file.pageCount == page+1){
        isFullView=true;

        //console.log('handle file end');
      }
      request({
        api: { method: "POST", url: "Media/UpdateVideoViewLog" },
        data: {
          attachId: _id,
          logId: this.viewLog.id,
          second: page,
          isFullView: isFullView != undefined ? isFullView : false,
        },
        store: this.$store,
      });
    },
    init() {
      let self = this;
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }

      fileInheritedDetail({ params: { id: _id }, store: this.$store }).then(
        (res) => {
          if (res != false) {
            this.file = res.data.file;
            for (let i = 1; i < this.file.pageCount + 1; i++) {
              self.imgs.push(`${self.file.link}?page=${i}&width=1200`);
            }
            this.$nextTick(() => {
              this.fileReady = true;
              this.fetchAfter();
            });
          }
        }
      );
    },
  },
};
</script>
